import { em } from 'polished'
import styled, { css } from 'styled-components'

import ButtonRounded from 'components/ButtonRounded'
import { Row } from 'styles/components/layout'

export const BannerIndent = styled.div`
  ${p => p.theme.mq.upMd} {
    height: ${p =>
      p.indent?.md ? em(p.indent.md) : p.theme.blocks.menuHeightMd};
  }

  ${p => p.theme.mq.upLg} {
    height: ${p =>
      p.indent?.lg ? em(p.indent.lg) : p.theme.blocks.menuHeightX2Md};
  }
`

export const GoodsBlock = styled.div`
  ${({ indented }) =>
    indented &&
    css`
      padding-top: ${p => p.theme.blocks.menuHeight};

      ${p => p.theme.mq.upMd} {
        padding-top: ${p => p.theme.blocks.menuHeightMd};
      }
    `};
`

export const FillFormBox = styled.div`
  padding-top: ${em(20)};

  ${p => p.theme.mq.upMd} {
    padding-top: ${em(40)};
  }
`

export const FormBox = styled.div`
  padding-top: ${em(40)};
`

export const DisclaimerBox = styled.div`
  padding-top: ${em(40)};
  padding-bottom: ${em(40)};

  ${p => p.theme.mq.upMd} {
    padding-top: ${em(60)};
    padding-bottom: ${em(60)};
  }
`

export const RowStyled = styled(Row)`
  justify-content: center;
  margin-top: ${em(30)};

  ${p => p.theme.mq.upMd} {
    justify-content: flex-end;
  }

  ${p => p.theme.mq.upLg} {
    justify-content: flex-end;
    margin-top: 0;
  }
`

export const ButtonRoundedStyled = styled(ButtonRounded)`
  width: 100%;

  ${p => p.theme.mq.upMd} {
    width: auto;
  }
`

export const ButtonContent = styled.div`
  padding: 0 ${em(46)};
  font-size: ${p => p.theme.typography.fontSize};
`

export const ButtonContentMobile = styled.div`
  text-align: center;

  ${p => p.theme.mq.upMd} {
    width: ${em(280)};
  }
`
